import { MenuEntry } from 'toonswap-uikit'
import { ContextApi } from 'contexts/Localization/types'

const config: (t: ContextApi['t']) => MenuEntry[] = (t) => [
  {
    label: t('Swap'),
    icon: 'HomeIcon',
    href: '/swap',
  },
  {
    label: t('Farms'),
    icon: 'FarmIcon',
    href: '/farms',
  },
  {
    label: t('Staking'),
    icon: 'PoolIcon',
    href: '/staking',
  },
  {
    label: 'Toon Pad',
    icon: 'IfoIcon',
    href: '/toon-pad',
  },
  {
    label: t('Rewards'),
    icon: 'MoreIcon',
    items: [
      {
        label: t('Referral Hub'),
        href: '/profile',
        // action: 'openProfileModal',
      },
      {
        label: t('Points Center'),
        href: '/points-center',
      },
      {
        label: t('Leaderboard'),
        href: '/leaderboard',
      },
    ],
  },
  {
    label: t('Docs'),
    icon: 'InfoIcon',
    href: 'https://toonswaps-organization.gitbook.io/toonswap/',
    target: '_blank',
  },
]

export default config
